import { useHeaderHeight } from "@react-navigation/elements";
import { View } from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";

export const HeaderSpacer = () => {
    const headerHeight = useHeaderHeight();
    const insets = useSafeAreaInsets();

    return (
        <View
            style={{
                height: Math.max(0, headerHeight - insets.top),
            }}
        />
    );
};
